import { configureStore } from "@reduxjs/toolkit";
import showMenuReducer from "./features/toggleMenuSlice";
import showUtilsReducer from "./features/utilsSlice";

export const store = configureStore({
  reducer: {
    showMenu: showMenuReducer,
    utils: showUtilsReducer,
  },
});
